module.exports = __webpack_public_path__ + "static/img/golden_staking_discount_coupon.74b20cb1.png";